"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcCollectionCostGen = exports.money = void 0;
const moment_1 = __importDefault(require("moment"));
const __1 = __importDefault(require(".."));
const vouchers_1 = require("../../vouchers");
const money = (n) => n * 100;
exports.money = money;
const calcCollectionCostGen = (selfCollectionCosts, foreignCollectionCosts) => (caseVouchers, documents, expirationSettings, selfCollection) => {
    const distributedVouchers = __1.default.interest.calculate(caseVouchers, documents, expirationSettings, (0, moment_1.default)().format());
    const principalTotalAmount = Math.round(Math.max(0, -__1.default.overview.balanceCategoryWithDistribution(distributedVouchers, vouchers_1.VoucherCategory.PRINCIPAL)) / 100);
    const costs = selfCollection ? selfCollectionCosts : foreignCollectionCosts;
    for (let i = 0; i < costs.tiers.length; i++) {
        const tier = costs.tiers[i];
        if (tier.from > principalTotalAmount) {
            continue;
        }
        if (tier.to != null && tier.to < principalTotalAmount) {
            continue;
        }
        return tier.value(principalTotalAmount);
    }
    throw new Error('Nonexhaustive costsTable');
};
exports.calcCollectionCostGen = calcCollectionCostGen;
//# sourceMappingURL=common.js.map